export default {
    title: state => {
        return state.title;
    },
    countries: state => {
        return state.countries;
    },
    issuedCountries: state => {
        return state.issuedCountries;
    },
    country: state => {
        return state.country;
    },
    countryToEdit: state => {
        return state.countryToEdit;
    },
    total: state => {
        return state.total;
    },
    isArabCountries: state => {
        return state.isArabCountries;
    },
    isArabCountry: state => {
        return state.isArabCountry;
    },
    code: state => {
        return state.code;
    },
    dialCode: state => {
        return state.dialCode;
    },
    status: state => {
        return state.status;
    },
}
